// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:26:54

export default {
  "id": "mow-it",
  "slug": "mow-it",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/a0a90186232d429db4573bb2d0dbcf4f-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/a0a90186232d429db4573bb2d0dbcf4f/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Mow It",
      "description": "Mow It Harvest is a colorful simulator in which you will have a farm and your own harvester at your disposal. You need to cut grass, sell colorful hay and move on to new levels. Cut grass like a real farmer and become a millionaire in this bright, exciting game!\n",
      "instructions": "For PCs:\n- Keyboard control via AWSD\n\nFor Mobile Devices:\n- Control via joystick. Control with one finger",
      "genres": [
        "Casual",
        "Simulation"
      ],
      "tags": [
        "build",
        "building",
        "farm",
        "grass"
      ]
    },
    "zh-CN": {
      "title": "割草",
      "description": "《割草收获》是一款色彩缤纷的模拟器，您将拥有一座农场和自己的收割机。您需要割草、出售五彩斑斓的干草并进入新关卡。像真正的农夫一样割草，在这款明亮、刺激的游戏中成为百万富翁！",
      "instructions": "对于PC：\n- 使用AWSD键进行键盘控制\n\n对于移动设备：\n- 通过摇杆控制。用一只手指控制",
      "genres": [
        "休闲",
        "模拟"
      ],
      "tags": [
        "建造",
        "建筑",
        "农场",
        "草地"
      ]
    },
    "zh-TW": {
      "title": "割草",
      "description": "割草收穫是一個多采多姿的模擬遊戲，在這款遊戲中，你將擁有一個農場和自己的收穫機。你需要割草、賣彩色的乾草並進入新的等級。像真農民一樣割草，在這款明亮、刺激的遊戲中成為一名百萬富翁！",
      "instructions": "對於PC：\n- 使用AWSD鍵盤控制\n\n對於行動裝置：\n- 使用摇桿控制。單指操控",
      "genres": [
        "休閒",
        "模擬"
      ],
      "tags": [
        "建造",
        "建築",
        "農場",
        "草地"
      ]
    },
    "zh-HK": {
      "title": "割草",
      "description": "割草收穫是一款色彩繽紛的模擬遊戲，您將擁有一個農場和自己的收穫機。您需要刪除草叢，賣出多彩的乾草並進入新等級。像真正的農民一樣割草，在這個明亮刺激的遊戲中成為百萬富翁！",
      "instructions": "對於電腦：\n- 使用AWSD鍵盤控制\n\n對於行動裝置：\n- 使用搖桿控制。單指操控",
      "genres": [
        "隨意",
        "模擬"
      ],
      "tags": [
        "建築",
        "建築物",
        "農場",
        "草地"
      ]
    },
    "ja": {
      "title": "草刈りましょう",
      "description": "Mow It Harvestは、自分の農場とハーベスターを自由に使えるカラフルなシミュレータです。草を刈り、カラフルな稲刈りを売り、新しいレベルに進む必要があります。真の農家のように草を刈り、この明るく刺激的なゲームで億万長者に！",
      "instructions": "PC:\n- キーボード操作（AWSDを使用）\n\nモバイルデバイス:\n- ジョイスティックで操作。一指で操作",
      "genres": [
        "カジュアル",
        "シミュレーション"
      ],
      "tags": [
        "建造",
        "建物",
        "農場",
        "草"
      ]
    },
    "ko": {
      "title": "모잎니다",
      "description": "모잘헵스는 농장과 자신의 수확기계를 소유한 다양한 색상의 시뮬레이터입니다. 초록색 풀을 베고, 다양한 색상의 말을 팔고 새로운 레벨로 진행해야 합니다. 진짜 농부처럼 초록색 풀을 베고, 이 빛나는 흥미로운 게임에서 백만장자가 되세요!",
      "instructions": "PC:\n- 키보드 조종 (AWSD)\n\n모바일 기기:\n- 조이스틱으로 조종. 한 손가락으로 조종",
      "genres": [
        "캐주얼",
        "시뮬레이션"
      ],
      "tags": [
        "건설",
        "건물",
        "농장",
        "풀"
      ]
    },
    "fr": {
      "title": "Tondre le gazon",
      "description": "Mow It Harvest est un simulateur coloré où vous disposerez d'une ferme et d'un récolteuse à votre disposition. Vous devez couper l'herbe, vendre du foin coloré et passer aux nouveaux niveaux. Coupez l'herbe comme un véritable agriculteur et devenez millionnaire dans ce jeu lumineux et captivant !",
      "instructions": "Pour les PC :\n- Contrôle au clavier via les touches AWSD\n\nPour les appareils mobiles :\n- Contrôle via le joystick. Contrôle avec un doigt",
      "genres": [
        "Décontracté",
        "Simulation"
      ],
      "tags": [
        "construire",
        "construction",
        "ferme",
        "herbe"
      ]
    }
  }
};
